export default "__VITE_ASSET__CRTF9NEx__"